/*
 * ConfirmationDialog Messages
 *
 * This contains all the text for the ConfirmationDialog component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.ConfirmationDialog';

export default defineMessages({
  yes: {
    id: `${scope}.yes`,
    defaultMessage: 'YES',
  },
  no: {
    id: `${scope}.no`,
    defaultMessage: 'NO',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'CANCEL',
  },
  ok: {
    id: `${scope}.ok`,
    defaultMessage: 'OK',
  },
});
